import VideoCard from '@/components/feature/VideoCard';
import { videos } from '@/mocks/videos';

export default function FeaturedSection() {
  const hotVideos = videos.filter((v) => v.isHot).slice(0, 4);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            <i className="ri-fire-line text-accent-500 mr-2"></i>
            热门推荐
          </h2>
          <a
            href="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotVideos.map((video, index) => (
            <div key={video.id} className={index === 0 ? 'sm:col-span-2 sm:row-span-2' : ''}>
              <VideoCard video={video} size={index === 0 ? 'large' : 'normal'} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}